'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { AuthTypePropType } from '../../TryIt/constants';
import { Operation } from '../../../lib/api-explorer/models/Oas';
import { RATE_LIMIT_DOCUMENTATION } from '../constants/urls';
import { getHasScopeSplitAccess } from '../../Auth/selectors';
import { getHasSplitScopesInSpec, getLegacyScopes, getGranularScopes, getSecurityTypes } from '../selectors/DocSelectors';
import { renderAuthTypes } from '../utils/DocsUtils';
import { SLINKY } from 'HubStyleTokens/colors';
import { TABLE_HEADER_FONT_SIZE } from 'HubStyleTokens/sizes';
import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import ScopesCollection from './ScopesCollection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import H5 from 'UIComponents/elements/headings/H5';
import UITable from 'UIComponents/table/UITable';
import UILink from 'UIComponents/link/UILink';
// import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTable = styled(UITable).withConfig({
  displayName: "Requirements__StyledTable",
  componentId: "n9fmhu-0"
})(["border-width:0;"]);
const sharedCellStyles = css(["&&{border-width:0;height:auto;text-align:left;}"]);
const sharedTHStyles = css(["", " font-weight:", ";font-size:", ";color:", ";text-transform:uppercase;"], sharedCellStyles, WEB_FONT_MEDIUM_WEIGHT, TABLE_HEADER_FONT_SIZE, SLINKY);
const StyledTH = styled.th.withConfig({
  displayName: "Requirements__StyledTH",
  componentId: "n9fmhu-1"
})(["", ""], sharedTHStyles);
const StyledScopeTH = styled.th.withConfig({
  displayName: "Requirements__StyledScopeTH",
  componentId: "n9fmhu-2"
})(["", " &&{vertical-align:top;line-height:26px;}"], sharedTHStyles);
const StyledTD = styled.td.withConfig({
  displayName: "Requirements__StyledTD",
  componentId: "n9fmhu-3"
})(["", " &&{line-height:26px;}"], sharedCellStyles);
class Requirements extends Component {
  renderRateLimit() {
    const {
      operation
    } = this.props;
    const rateLimit = operation['x-hubspot-rate-limit-exemptions'];
    let i18nKey;
    if (!rateLimit || !Array.isArray(rateLimit)) {
      i18nKey = 'standard';
    } else if (rateLimit.length === 2) {
      i18nKey = 'both';
    } else {
      i18nKey = rateLimit[0];
    }
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `developer-docs-shared-components.requirements.limits.${i18nKey}_jsx`,
      options: {
        href: RATE_LIMIT_DOCUMENTATION,
        external: true
      },
      elements: {
        Link: UILink
      }
    });
  }
  renderLegacyScopeHeaderText() {
    const {
      hasScopeSplitAccess,
      hasSplitScopesInSpec
    } = this.props;
    if (hasScopeSplitAccess && hasSplitScopesInSpec) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.requirements.scopes.header.standardScopes"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-docs-shared-components.requirements.scopes.header.scopes"
    });
  }
  render() {
    const {
      hasScopeSplitAccess,
      hasSplitScopesInSpec,
      granularScopes,
      legacyScopes,
      newLayout,
      securityTypes
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "m-bottom-6",
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.requirements.header"
        })
      }), /*#__PURE__*/_jsxs(StyledTable, {
        bordered: false,
        condensed: true,
        hover: false,
        children: [/*#__PURE__*/_jsxs("colgroup", {
          children: [/*#__PURE__*/_jsx("col", {
            style: {
              width: '152px'
            }
          }), /*#__PURE__*/_jsx("col", {})]
        }), /*#__PURE__*/_jsxs("tbody", {
          children: [/*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx(StyledScopeTH, {
              children: this.renderLegacyScopeHeaderText()
            }), /*#__PURE__*/_jsx(StyledTD, {
              children: /*#__PURE__*/_jsx(ScopesCollection, {
                scopesCollection: legacyScopes
              })
            })]
          }), hasScopeSplitAccess && hasSplitScopesInSpec && /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx(StyledScopeTH, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-shared-components.requirements.scopes.header.granularScopes"
              })
            }), /*#__PURE__*/_jsx(StyledTD, {
              children: /*#__PURE__*/_jsx(ScopesCollection, {
                scopesCollection: granularScopes
              })
            })]
          }), /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx(StyledTH, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-docs-shared-components.requirements.limits.header"
              })
            }), /*#__PURE__*/_jsx(StyledTD, {
              children: this.renderRateLimit()
            })]
          }), newLayout && /*#__PURE__*/_jsxs("tr", {
            className: "auth-types",
            children: [/*#__PURE__*/_jsx(StyledTH, {
              children: /*#__PURE__*/_jsx("span", {
                children: "Auth Methods"
              })
            }), /*#__PURE__*/_jsx(StyledTD, {
              children: renderAuthTypes(securityTypes)
            })]
          })]
        })]
      })]
    });
  }
}
Requirements.propTypes = {
  doc: PropTypes.shape({
    _id: PropTypes.string.isRequired
  }),
  hasScopeSplitAccess: PropTypes.bool.isRequired,
  hasSplitScopesInSpec: PropTypes.bool.isRequired,
  newLayout: PropTypes.bool,
  operation: PropTypes.instanceOf(Operation).isRequired,
  granularScopes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  securityTypes: PropTypes.arrayOf(AuthTypePropType).isRequired,
  legacyScopes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired
};
const select = (state, ownProps) => ({
  hasScopeSplitAccess: getHasScopeSplitAccess(),
  hasSplitScopesInSpec: getHasSplitScopesInSpec(state, ownProps),
  granularScopes: getGranularScopes(state, ownProps),
  legacyScopes: getLegacyScopes(state, ownProps),
  securityTypes: getSecurityTypes(state, ownProps).sort().reverse()
});
export default connect(select)(Requirements);